import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { BlurredImage } from "../common/BlurredImage"

const getUrl = (itemName) => {
  let url = itemName !== "alchemy+" ? itemName.replace(" ", "-").toLowerCase() : "";
  return url.toLowerCase();
};

const NavSearchDropdown = ({ items, keyword }) => {
  // const [isScrollButtonVisible, setIsScrollButtonVisible] = useState(false);
  const containerRef = useRef(null);

  // const handleScroll = () => {
  //   if (containerRef.current) {
  //     const scrollTop = containerRef.current.scrollTop;
  //     setIsScrollButtonVisible(scrollTop > 200);
  //   }
  // };

  // const scrollToTop = () => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollTo({
  //       top: 0,
  //       behavior: 'smooth'
  //     });
  //   }
  // };

  if (!items) return null;

  return (
    <div className="w-full">
      <div className="container position-relative">
        {/* {isScrollButtonVisible && (
          <div onClick={scrollToTop} id="search-scroll-up">
            <img src="/images/icons/scroll-up.svg" alt="scroll-up" />
            TOP
          </div>
        )} */}
        <div
          ref={containerRef}
          // onScroll={handleScroll}
          className="w-full"
          id="search-results"
        >
          <div className="row my-4">
            {items.length === 0 && keyword.trim().length > 0 ? (
              <div className="w-full text-center">{`No results found for "${keyword}"`}</div>
            ) : (
              items.map((item, index) => (
                <div className="col-6 col-md-4 col-lg-3 d-flex flex-column justify-content-start align-items-center" key={index}>
                  <a href={`/item/${getUrl(item.item_name)}/${getUrl(item.item_number)}`}>
                    <BlurredImage imageUrl={`https://www.innovationsusa.com/storage/sku/150x150/${item.item_number}.jpg?v=0.6`} />
                  </a>
                  <a href={`/item/${getUrl(item.item_name)}`} className="py-1 text-uppercase">
                    {item.item_name}
                  </a>
                  <a href={`/item/${getUrl(item.item_name)}/${getUrl(item.item_number)}`} className="mb-2 text-uppercase">
                    {item.item_number} <span style={{ fontSize: '0.7rem' }}>{item.color_name}</span>
                  </a>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export const NavSearchResult = () => {
  const [keyword, setKeyword] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const cancelToken = useRef(null);

  useEffect(() => {
    if (cancelToken.current) {
      cancelToken.current.cancel('Component unmounted: Canceling pending requests');
    }
    cancelToken.current = Axios.CancelToken.source();

    const fetchData = async () => {
      if (keyword.trim().length) {
        try {
          const res = await Axios.post("/get-searched-products", {
            keyword: keyword.trim(),
          }, {
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-TOKEN": csrfToken,
            },
            cancelToken: cancelToken.current.token,
          });

          setSearchResults(res.data.data || []);
        } catch (err) {
          console.error(err);
          setSearchResults([]);
        }
      } else {
        setSearchResults([]);
      }
    };

    fetchData();

    return () => {
      if (cancelToken.current) {
        cancelToken.current.cancel();
      }
    };
  }, [keyword]);

  const clearSearch = () => {
    const searchBox = document.getElementById('search-box');
    setKeyword('');
    setSearchResults([]);
    searchBox.classList.toggle('collapsed');
  }
  return (
    <div className="d-flex flex-column align-items-center">
      <div id="search-input-container" className="col-10 col-md-6">
        <input
          id="search-input"
          type="text"
          placeholder="Search by product, color, material, pattern, etc."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          autoComplete="off"
        />
        <img
          src="/images/icons/x.svg"
          alt="close-icon"
          id="search-close-icon"
          onClick={clearSearch}
        />
      </div>
      {
        keyword.trim().length > 0 &&
        <NavSearchDropdown items={searchResults} keyword={keyword} />
      }
    </div>
  );
};

export const NavSearchButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const searchBox = document.getElementById('search-box');
    if (searchBox) {
      searchBox.classList.toggle('collapsed');
      const searchInput = document.getElementById('search-input');
      if (searchInput) {
        searchInput.focus();
      }
    }
  }

  return (
    <a href="#" onClick={(e) => handleClick(e)} >
      <img className="search-ico" src="/images/icons/Search.svg" />
    </a>
  );
}